module.exports = __webpack_public_path__ + "img/perfume_advertisement.8da80e29.jpg";